import { useContext, useMemo, useCallback } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { BusinessCollectionCompType } from '../../../../../../Types/ObjektVy';
import { collectionCompToObjektVy } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionUtils';
import {
  DemoLeverantorQuery_node_TEDLRLeverantor as leverantor_node,
  DemoLeverantorQuery as leverantor,
  DemoLeverantorQueryVariables as leverantorVariables,
  DemoLeverantorQuery_node_TEDLRLeverantor__Associations as Associations,
} from './_QueryTypes/DemoLeverantorQuery';
import { useCollectionMutation } from '../../../../../../Components/QueryComponents/CollectionMutation/useCollectionMutation';
import UpdateMutation from './DemoLeverantorUpdateMutation.gql';
import AddMutation from './DemoLeverantorAddMutation.gql';
import LeverantorQuery from './DemoLeverantorQuery.gql';
import {
  LeverantorUpdateMutation as IUpdateData,
  LeverantorUpdateMutationVariables as IUpdateVariables,
} from '../../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorUpdateMutation';
import {
  LeverantorAddMutation as IAddData,
  LeverantorAddMutationVariables as IAddVariables,
} from '../../../../Leverantor/ObjektVyer/Leverantor/_QueryTypes/LeverantorAddMutation';
import BusinessDataForm from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import clientAvenyModel from '../../../../../../Model/clientAvenyModel';
import ObjektVySida from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import { ObjektVyKort } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import Attribut from '../../../../_Common/Components/BusinessCollectionComponents/Attribut/Attribut';
import IntegratedAssociationList from '../../../../_Common/Components/BusinessCollectionComponents/IntegratedAssociationList/IntegratedAssociationList';
import ObjektVy from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVy/ObjektVy';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { ObjektLank } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import {
  AssociationList,
  IAssociationListConfig,
} from '../../../../_Common/Components/BusinessCollectionComponents/AssociationList/AssociationList';
import { OrgPersLokGruppForm } from '../../../../OP/ObjektVyer/OrgPersLok/OrgPersLok';
import AssocieradObjektVy from '../../../../_Common/Components/BusinessCollectionComponents/AssocieradObjektVy/AssocieradObjektVy';
import { ObjektVyFaltLista } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyFaltLista/ObjektVyFaltLista';
import AttributGrupp from '../../../../_Common/Components/BusinessCollectionComponents/AttributGrupp/AttributGrupp';
import {
  removeIdsFromNewAssociations,
  IFormData,
  IFieldValidations,
  IValidateFn,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import UtbetalningssattQuery from './DemoUtbetalningssattQuery.gql';
import {
  DemoUtbetalningssattQuery as UtbetalningssattQueryData,
  DemoUtbetalningssattQueryVariables as UtbetalningssattQueryVariables,
} from './_QueryTypes/DemoUtbetalningssattQuery';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { leverantorFormStateActionTransformer } from '../../../../Leverantor/ObjektVyer/Leverantor/Utils/leverantorUtils';
import AttributeHeader from '../../../../../../Components/Attributes/AttributeHeader/AttributeHeader';
import {
  TEDLRLeverantorSTATUSEnum,
  TEDOPOrgPersLokTypEnum,
  TEDOPOrgPersLokLOKALADREnum,
  TEDOPOrgPersLokREGELEnum,
  TEDInputLRLeverantorAddValues,
  TEDSelectionConditionType,
  TEDSelectionOperator,
} from '../../../../../../globalQueryTypes';
import ObjectSubCard from '../../../../_Common/Components/ObjectSubCard';
import { GridContext } from '../../../../../GridContext';
import { ObjektVyKortDel } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKortDel';
import { EDInputGroup } from '../../../../../../BaseComponents/InputGroup/EDInputGroup';
import { defaultBusinessCollectionMenuItem } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessCollectionMenu/Utils/BusinessCollectionMenuUtils';
import { head, mergeDeepRight } from 'ramda';
import { emptyUrvalNoPages } from '../../../../../../Components/Urval/Utils/urvalUtils';
import { DeepPartial } from '../../../../../../Types/UtilTypes';
import { definedSelectedId } from '../../../../../../Components/MasterDetail/MasterDetailUtils';
import { useSelectedDetailQuery } from '../../../../../../Components/QueryComponents/SelectedDetailQuery/useSelectedDetailQuery';
import { ICustomValidValues } from '../../../../../../Types/ColumnDefType';
import { convertTEDUrvalToUIUrval } from '../../../../../../Components/Urval/Utils/convertTEDUrvalToUIUrval';
import { collectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import { useActiveDBCollectionQuery } from '../../../../../../Components/QueryComponents/ActiveDBCollectionQuery/ActiveDBCollectionQuery';

const leverantormodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantor;
const orgperslokmodel: IClientBusinessModel =
  clientAvenyModel.OP.BusinessModels.OPOrgPersLok;

//Endast i demo, kontonummer som slutar på 2 får välja den hemliga banken
//För övriga konton sorterar vi bort irländska banker.
//I frågan som hämtar defaultvalues så hämtar vi bara banker med postnummer
const validBanks: ICustomValidValues = {
  skipDefaultValues: false,
  validValuesFunction: (defaultValues, formState) => {
    return formState?.currentValues?.['KONTO_NR']?.endsWith('2')
      ? [{ name: 'secret bank', value: head(defaultValues)?.value ?? 'sorry' }]
      : defaultValues.filter(
          option => option.data?._Associations?.Land?.LANDKOD !== 'IE'
        );
  },
  dataDependencies: ['Land.LANDKOD'],
  urval: convertTEDUrvalToUIUrval(
    'SYSBank',
    [
      [
        {
          namn: 'POSTNUMMER',
          typ: TEDSelectionConditionType.Value,
          valueCondition: { op: TEDSelectionOperator.hasvalue },
        },
      ],
    ],
    collectionMap
  ).unsafelyUnwrap(),
};
const levBetalningssattConfig: IAssociationListConfig = {
  inCard: true,
  integrated: true,
  defaultVisningstyp: 'tabell',
  customDefaultColumns: [
    { attributeDef: 'IDString', caption: 'Utbetalningssätt', header: true },
    { attributeDef: 'KONTO_NR' },
    { attributeDef: 'NUMERISKA_FAKTURANR' },
    { attributeDef: 'OCR' },
    {
      association: 'Bank',
      attributeDef: '',
      customValidValues: validBanks,
    },
  ],
  customBusinessConfig: { associations: { Bank: { disableArrowIcon: true } } },
};

const kontaktConfig: IAssociationListConfig = {
  inCard: true,
  integrated: true,
  defaultVisningstyp: 'tabell',
  customDefaultColumns: [
    { attributeDef: 'NAMN' },
    { attributeDef: 'Adress.CO' },
    { association: 'Anvandare', attributeDef: 'Name' },
  ],
};
const fakturamodel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRLeverantorfaktura;

const validateSparrdatum: IValidateFn<leverantor_node> = ({
  currentValues,
}): IFieldValidations => {
  const errorMessages: IFieldValidations = [];
  const regDatum = Date.parse(currentValues.REGDATUM);
  const sparrDatum = Date.parse(currentValues.SPARRAD_FROM_DATUM);

  if (sparrDatum && regDatum && sparrDatum < regDatum) {
    errorMessages.push({
      fieldName: 'SPARRAD_FROM_DATUM',
      message: 'Leverantör kan inte spärras innan registreringsdatum',
      type: 'Error',
    });
  }

  return errorMessages;
};

// värden som alltid ska förslås
const baseInitialValue: DeepPartial<TEDInputLRLeverantorAddValues> = {
  STATUS: TEDLRLeverantorSTATUSEnum.NORMAL,
  _Associations: {
    OrgPers_Values: {
      _typ: TEDOPOrgPersLokTypEnum.OVRIGORG,
      REGEL: TEDOPOrgPersLokREGELEnum.STANDARD,
      LOKALADR: TEDOPOrgPersLokLOKALADREnum.LOKAL,
      _Associations: {
        Adress_Values: {},
      },
    },
  },
};

const Leverantor: BusinessCollectionCompType = props => {
  const id = props.id ? props.id : '';
  const {
    nodeData,
    loading: nodeLoading,
    refetch: nodeRefetch,
  } = useSelectedDetailQuery<leverantor, leverantor_node, leverantorVariables>(
    LeverantorQuery,
    props.id
  );

  const [mutation, { loading, error }] = useCollectionMutation<
    IUpdateData,
    IUpdateVariables
  >(UpdateMutation);

  const [addMutation, addStatus] = useMutation<IAddData, IAddVariables>(
    AddMutation
  );

  const { activeDatabase } = useContext(ActiveDatabaseContext);

  const attestforslagConfig = useMemo((): IAssociationListConfig => {
    return {
      defaultVisningstyp: 'lista',
      inCard: true,
      customDefaultColumns: [
        { attributeDef: 'IDString', caption: 'Referens', header: true },
        {
          attributeDef: 'MottagandeEnhet.Namn',
          caption: 'Mottagande enhet',
        },
      ],
      businessCollectionMenuItems: [
        defaultBusinessCollectionMenuItem.Add,
        defaultBusinessCollectionMenuItem.Urval,
        defaultBusinessCollectionMenuItem.Columns,
        defaultBusinessCollectionMenuItem.Refetch,
        defaultBusinessCollectionMenuItem.ExportExcel,
      ],
      highlightedBusinessCollectionMenuItem:
        defaultBusinessCollectionMenuItem.Add.id,
    };
  }, []);

  const updateFunction = useCallback(
    (values: IFormData) => {
      const newValues = removeIdsFromNewAssociations(values);
      return mutation({
        variables: {
          db: activeDatabase || '',
          values: {
            id: definedSelectedId(id),
            _version: nodeData ? nodeData._version : 1,
            ...newValues,
          },
        },
      });
    },
    [mutation, activeDatabase, id, nodeData]
  );

  const addFunction = useCallback(
    (values: IFormData) => {
      return addMutation({
        variables: {
          db: activeDatabase || '',
          values: values as TEDInputLRLeverantorAddValues,
        },
      });
    },
    [addMutation, activeDatabase]
  );

  const { data: utbetalningssattData } = useQuery<
    UtbetalningssattQueryData,
    UtbetalningssattQueryVariables
  >(UtbetalningssattQuery, {
    variables: { databaseName: activeDatabase || '' },
    skip: !activeDatabase,
  });

  //hämta leverantörskategorier och föreslå kategori om det bara finns en
  const { data: levkategoridata } = useActiveDBCollectionQuery({
    collectionName: 'LRLeverantorkat',
    attributeDefs: ['id'],
    urval: emptyUrvalNoPages,
  });
  const defaultLevKat =
    levkategoridata != null && levkategoridata.length === 1
      ? levkategoridata.at(0)?.id
      : null;

  const initialValue: IFormData = useMemo(
    () =>
      mergeDeepRight(baseInitialValue, {
        _Associations: { Leverantorskategori_Ref: defaultLevKat },
      }),
    [defaultLevKat]
  );

  return (
    <BusinessDataForm<leverantor_node>
      isNew={props.isNew}
      data={nodeData}
      model={leverantormodel}
      updateMutation={updateFunction}
      addMutation={addFunction}
      fullScreen={props.config?.fullPage ?? false}
      mutationError={error || addStatus.error}
      mutationLoading={loading || addStatus.loading}
      formStateActionTransformer={leverantorFormStateActionTransformer(
        utbetalningssattData?.db?.SYSUtbetalningssatt_All || [],
        nodeData?.OPTyp ?? null
      )}
      newFormContext
      initialValue={initialValue}
      validateFns={[validateSparrdatum as IValidateFn]}
      refetchData={nodeRefetch}
      dataLoading={nodeLoading}
    >
      <ObjektVy nodeLoading={nodeLoading} editImplemented>
        <ObjektVySida
          sidNr={1}
          caption="Leverantör"
          collectionName={leverantormodel.CollectionName}
        >
          <ObjektVyKolumner>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <AttributGrupp>
                <EDInputGroup>
                  <AttributeHeader
                    attributeGroups={[
                      'LEVERANTORSNR',
                      'OrgPers.ORG_NAMN',
                      ['OrgPers.FORNAMN', 'OrgPers.EFTERNAMN'],
                    ]}
                  />
                  <GridContext.Provider value={{ inGrid: true }}>
                    <ObjektVyKortDel>
                      <Attribut<leverantor_node>
                        name="LEVERANTORSNR"
                        mode="edit"
                      />
                      <Attribut<leverantor_node> name="KUNDNR" />
                    </ObjektVyKortDel>
                  </GridContext.Provider>
                </EDInputGroup>
              </AttributGrupp>
              <GridContext.Provider value={{ inGrid: true }}>
                <ObjektVyKort>
                  <EDInputGroup>
                    <AssocieradObjektVy
                      association={leverantormodel.Associations.OrgPers}
                      vy={
                        <OrgPersLokGruppForm
                          autoFocus={props.isNew}
                          association={leverantormodel.Associations.OrgPers}
                        />
                      }
                    />
                  </EDInputGroup>
                  <AssociationList
                    associationName="Kontakter"
                    associationPath="OrgPers.Kontakter"
                    collectionName={orgperslokmodel.CollectionName}
                    ownId={definedSelectedId(id)}
                    config={kontaktConfig}
                  />
                </ObjektVyKort>
                <ObjektVyKort caption="Betalningsinformation">
                  <ObjektVyFaltLista>
                    <EDInputGroup>
                      <ObjektLank<Associations>
                        associationName="Betalningsvillkor"
                        id={
                          nodeData &&
                          nodeData._Associations &&
                          nodeData._Associations.Betalningsvillkor
                            ? nodeData._Associations.Betalningsvillkor.id
                            : null
                        }
                      />
                      <ObjektLank<Associations>
                        associationName="Valuta"
                        id={
                          nodeData &&
                          nodeData._Associations &&
                          nodeData._Associations.Valuta
                            ? nodeData._Associations.Valuta.id
                            : null
                        }
                      />
                      <Attribut<leverantor_node> name="RIKSBANKSKOD" />
                    </EDInputGroup>
                  </ObjektVyFaltLista>
                  <ObjectSubCard>
                    <AssociationList
                      associationName="LevBetalningssatt"
                      associationPath="LevBetalningssatt"
                      collectionName={leverantormodel.CollectionName}
                      ownId={definedSelectedId(id)}
                      config={levBetalningssattConfig}
                    />
                    <IntegratedAssociationList<Associations>
                      title="Leverantörens betalningssätt"
                      associationName="LevBetalningssatt"
                      label={{
                        name: 'Utbetalningssatt',
                        association: true,
                        mode: 'edit',
                      }}
                      labelAttributeNames={[{ name: 'KONTO_NR', mode: 'edit' }]}
                      contentAttributeNames={[
                        { name: 'NUMERISKA_FAKTURANR' },
                        { name: 'OCR' },
                        { name: 'Bank', association: true },
                      ]}
                    />
                  </ObjectSubCard>
                </ObjektVyKort>
              </GridContext.Provider>
            </ObjektVyKolumn>
            <ObjektVyKolumn fullPage={props.config?.fullPage ?? false}>
              <GridContext.Provider value={{ inGrid: true }}>
                <AttributGrupp caption="Övrigt">
                  <EDInputGroup>
                    <Attribut<leverantor_node> name="ANGE_KUNDNR_SOM_FAKTREF" />
                    <Attribut<leverantor_node> name="RABATT" />
                    <Attribut<leverantor_node> name="REGDATUM" />
                    <Attribut<leverantor_node> name="SPARRAD_FROM_DATUM" />
                    <Attribut<leverantor_node> name="FSKATT_KONTROLLERAD_DATUM" />
                    <ObjektLank<Associations>
                      associationName="Leverantorskategori"
                      id={
                        nodeData &&
                        nodeData._Associations &&
                        nodeData._Associations.Leverantorskategori
                          ? nodeData._Associations.Leverantorskategori.id
                          : null
                      }
                    />
                    <ObjektLank<Associations>
                      associationName="Leveransvillkor"
                      id={
                        nodeData &&
                        nodeData._Associations &&
                        nodeData._Associations.Leveransvillkor
                          ? nodeData._Associations.Leveransvillkor.id
                          : null
                      }
                    />
                    <ObjektLank<Associations>
                      associationName="Moms"
                      id={
                        nodeData &&
                        nodeData._Associations &&
                        nodeData._Associations.Moms
                          ? nodeData._Associations.Moms.id
                          : null
                      }
                    />
                    <Attribut<leverantor_node> name="ORDINARIE_REFERENS_TYP" />
                  </EDInputGroup>
                </AttributGrupp>
                <ObjektVyKort caption="LEVERANTÖRSFAKTURAREFERENSER">
                  {id && (
                    <AssociationList
                      collectionName={leverantormodel.CollectionName}
                      ownId={definedSelectedId(id)}
                      config={attestforslagConfig}
                      associationName="Attestforslag"
                    />
                  )}
                </ObjektVyKort>
              </GridContext.Provider>
            </ObjektVyKolumn>
          </ObjektVyKolumner>
        </ObjektVySida>
        <ObjektVySida
          disableMasonry
          sidNr={2}
          caption="Fakturor"
          columns={1}
          collectionName={fakturamodel.CollectionName}
          leftMenuPresent
        >
          {/*  FIXME: Bättre lösning? */}
          {id && (
            <AssociationList
              collectionName={leverantormodel.CollectionName}
              ownId={definedSelectedId(id)}
              associationName="Fakturor"
            />
          )}
        </ObjektVySida>
      </ObjektVy>
    </BusinessDataForm>
  );
};

export const demoVyPS = collectionCompToObjektVy(Leverantor, 'demoVyPS');
